
// custom js  - scroll animation

const images = document.querySelectorAll('.custom-scroll-container');

const options = {
  root: null, 
  threshold: 0.1
};

const callback = (entries, observer) => {
  entries.forEach((entry, index) => {
    if (entry.isIntersecting) {
      setTimeout(() => {        
        if (entry.target.classList.contains('left-right')) {
          entry.target.classList.add('lp-visible', 'left-right');
        } else if (entry.target.classList.contains('right-left')) {
          entry.target.classList.add('lp-visible', 'right-left');
        } else if (entry.target.classList.contains('top-bottom')) {
          entry.target.classList.add('lp-visible', 'top-bottom');
        } else {
          entry.target.classList.add('lp-visible');
        }
      }, index * 200); 
      
      observer.unobserve(entry.target);
    }
  });
};

const observer = new IntersectionObserver(callback, options);

images.forEach(image => observer.observe(image));


// custom js  - star

  const starColors = ["#ffe785", "#fff1b9", "#f6d13c"];
  const starSizes = [10, 20, 30];
  const maxStars = 50;

 let firstStarCreated = false; 


  function createStar() {

    if (document.querySelectorAll('.star').length >= maxStars) {
      return;
    }
    
    const star = document.createElement('div');
    star.classList.add('star');
    

    const color = starColors[Math.floor(Math.random() * starColors.length)];
    const size = starSizes[Math.floor(Math.random() * starSizes.length)];
    

    star.style.backgroundColor = color;
    star.style.width = `${size}px`;
    star.style.height = `${size}px`;
    
    document.querySelector('.star-container').appendChild(star);


    if (!firstStarCreated) {
      star.style.animationDuration = `${Math.random() * 10+ 15}s`; 
      star.style.animationDelay = "0s"; 
      firstStarCreated = true; 
    } else {
 
      star.style.animationDuration = `${Math.random() * 10 + 15}s`; 
      star.style.animationDelay = `${Math.random() * 5}s`; 
    }


    star.style.left = `${Math.random() * 100}vw`;
    

    star.addEventListener('animationend', () => {
      star.remove();
    });
  }

 
  setInterval(createStar, 1000);


  // custom js  - snow


    const snowSizes = [4, 6, 8, 10]; 
  const maxSnowflakes = 50;
  let firstSnowCreated = false;

  function createSnow() {
    if (document.querySelectorAll('.snow').length >= maxSnowflakes) return;

    const snow = document.createElement('div');
    snow.classList.add('snow');

    const size = snowSizes[Math.floor(Math.random() * snowSizes.length)];
    snow.style.width = `${size}px`;
    snow.style.height = `${size}px`;

    snow.style.left = `${Math.random() * 100}vw`;

    if (!firstSnowCreated) {
      snow.style.animationDuration = `${Math.random() * 10 + 10}s`;
      snow.style.animationDelay = "0s";
      firstSnowCreated = true;
    } else {
      snow.style.animationDuration = `${Math.random() * 10 + 10}s`;
      snow.style.animationDelay = `${Math.random() * 5}s`;
    }

    document.querySelector('.snow-container').appendChild(snow);

    snow.addEventListener('animationend', () => {
      snow.remove();
    });
  }

  setInterval(createSnow, 500);




